import CarrierStatus from '../../../enums/carrier-status.enum';
import ICarriersFiltersModel from '../../../interfaces/ICarriersFiltersModel';

const emptyActiveCarrierFilterModel: ICarriersFiltersModel = {
    status: CarrierStatus.active,
    regions: [],
};

export default emptyActiveCarrierFilterModel;
